export const mapTypes = {
  markers: () => import('@/components/smart/YaMapMarkers'),
  polygons: () => import('@/components/smart/YaMapPolygons')
}
